// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-section .download-container {
  display: flex;
  align-items: center;
  max-width: 660px;
  margin: 0 auto;
}
.download-section .download-content {
  padding-left: 40px;
}
.download-section .download-content h2 {
  padding-top: 8px;
}
.download-section .download-content p {
  font-size: 14px;
}
.download-section .download-content .qr-code {
  padding-top: 40px;
}
.download-section .download-store {
  display: flex;
  flex-wrap: wrap;
  margin: -12px;
  padding-top: 24px;
  max-width: 80%;
}
.download-section .download-store li {
  width: 50%;
  padding: 12px;
}
.download-section .download-store li img {
  width: 100%;
}

@media only screen and (min-width: 0px) and (max-width: 767px) {
  .download-container {
    max-width: 100%;
    margin: 0;
  }
  .download-container .phone {
    display: none;
  }
  .download-container .download-content {
    padding-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/DownloadSection/DownloadSection.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAEE;EACE,kBAAA;AAAJ;AACI;EACE,gBAAA;AACN;AACI;EACE,eAAA;AACN;AACI;EACE,iBAAA;AACN;AAEE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AAAJ;AACI;EACE,UAAA;EACA,aAAA;AACN;AAAM;EACE,WAAA;AAER;;AAMA;EACI;IACE,eAAA;IACA,SAAA;EAHJ;EAII;IACI,aAAA;EAFR;EAII;IACI,eAAA;EAFR;AACF","sourcesContent":[".download-section{\r\n  .download-container{\r\n    display: flex;\r\n    align-items: center;\r\n    max-width: 660px;\r\n    margin: 0 auto;\r\n  }\r\n  .download-content{\r\n    padding-left: 40px;\r\n    h2{\r\n      padding-top: 8px;\r\n    }\r\n    p{\r\n      font-size: 14px;\r\n    }\r\n    .qr-code{\r\n      padding-top: 40px;\r\n    }\r\n  }\r\n  .download-store{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin: -12px;\r\n    padding-top: 24px;\r\n    max-width: 80%;\r\n    li{\r\n      width: calc(100% / 2);\r\n      padding: 12px;\r\n      img{\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n    .download-container{\r\n      max-width: 100%;\r\n      margin: 0;\r\n      .phone{\r\n          display: none;\r\n      }\r\n      .download-content{\r\n          padding-left: 0;\r\n      }\r\n      \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
